import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../../components/common/ShadowCard";
import {
  clearAttendanceSummaryReportDetails,
  clearAttendanceSummaryReportList,
  setAttendanceSummaryReport,
} from "../reportsSlice";
import AlertBox from "../../../components/common/AlertBox";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import { getAllAttendanceSummaryReport } from "../services/reports.services";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import FormCheckboxGroup from "../../../components/formFields/FormCheckboxGroup";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import FormDatePicker from "../../../components/formFields/FormDateField";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { getAllSalesRepresentative } from "../../salesrepresentativeassign/services/salesRepresentative.services";
import { ISalesRepresentative } from "../../salesrepresentativeassign/salesRepresentativeModel";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const ChangeWatcher = ({ formRenderProps }: FormChangeWatcherProps) => {
  useEffect(() => {
    formRenderProps.onChange("abcd", { value: "forenable" });
  }, []);

  return null;
};

const AttendanceSummaryReportForm: React.FC = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);

  const AttendanceSummaryReportDetails = useAppSelector(
    (state) => state.reports.AttendanceSummaryReportDetails
  );
  const AttendanceSummaryReportList = useAppSelector(
    (state) => state.reports.AttendanceSummaryReportList
  );
  const SalesRepresentativeList = useAppSelector(
    (state) => state.salesrepresentative.SalesRepresentativeList
  );
  //   const currentPage = useAppSelector((state) => state.pagination.currentPage);
  //   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  useEffect(() => {
    dispatch(getAllSalesRepresentative());
    return () => {
      dispatch(clearAttendanceSummaryReportDetails());
      dispatch(clearAttendanceSummaryReportList());

      //   dispatch(setCurrentPage(0));
    };
  }, []);
  const handleSubmit = async (values: any) => {
    const payload = {
      sr_id: values?.sr_id ? values?.sr_id : null,
      from_date: values?.from_date
        ? moment(values?.from_date).format("YYYY-MM-DD")
        : "",
      to_date: values?.to_date
        ? moment(values?.to_date).format("YYYY-MM-DD")
        : "",
      limit: 10,
      skip: 0,
    };
    dispatch(
      setAttendanceSummaryReport({
        sr_id: values?.sr_id ? values?.sr_id : null,
        from_date: values?.from_date,
        to_date: values?.to_date,
      })
    );
    await dispatch(getAllAttendanceSummaryReport(payload));
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            initialValues={AttendanceSummaryReportDetails}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <ChangeWatcher formRenderProps={formRenderProps} />
                  <GridLayoutItem colSpan={4}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Attendance Summary Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={{ width: "100%" }}>
                    <Field
                      name="sr_id"
                      label={"Sales Representative"}
                      placeholder="Select Sales Representative"
                      component={FormSelectionField}
                      // validator={requiredValidator}
                      // astrike={true}
                      options={SalesRepresentativeList?.map(
                        (expensetype: ISalesRepresentative) => {
                          return {
                            value: expensetype?.id,
                            label: `${expensetype?.first_name} ${expensetype?.middle_name} ${expensetype?.last_name}`,
                          };
                        }
                      )}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="from_date"
                      label="From Date"
                      format={"dd/MM/yyyy"}
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="to_date"
                      label="To Date"
                      format={"dd/MM/yyyy"}
                      minDate={
                        formRenderProps.valueGetter("from_date") ||
                        new Date(1900, 1, 1)
                      }
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <div style={{ marginTop: "35px" }}>
                      <ButtonWithLoading
                        label={"View"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </ShadowCard>
        {loading ? (
          <LoadingPanel gridRef={gridRef} />
        ) : (
          AttendanceSummaryReportList &&
          AttendanceSummaryReportList.length > 0 && (
            <ShadowCard style={{ marginTop: 10, minHeight: "30vh" }}>
              <AttendanceSummaryExportTable />
            </ShadowCard>
          )
        )}
      </GridLayoutItem>
    </GridLayout>
  );
};

const AttendanceSummaryExportTable: React.FC = () => {
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );
  const AttendanceSummaryReportList = useAppSelector(
    (state) => state.reports.AttendanceSummaryReportList
  );
  const AttendanceSummaryReportDetails = useAppSelector(
    (state) => state.reports.AttendanceSummaryReportDetails
  );

  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const handlePrint = (props: any, type: string) => {
    const state = {
      sr_id: props?.sr_id ? props?.sr_id : null,
      from_date: props?.from_date
        ? moment(props?.from_date).format("YYYY-MM-DD")
        : "",
      to_date: props?.to_date
        ? moment(props?.to_date).format("YYYY-MM-DD")
        : "",
      initialValues: props.initialValues,
    };

    if (type === "attendancesummaryreport") {
      sessionStorage.setItem(
        "attendancesummaryreportState",
        JSON.stringify(state)
      );
      const reportTab = window.open("/attendancesummaryreportprint", "_blank");
      const interval = setInterval(() => {
        if (reportTab?.closed) {
          sessionStorage.removeItem("attendancesummaryreportState");
          clearInterval(interval);
        }
      }, 1000);
    }
  };

  const handleExportExcel = () => {
    /*===*===* YOUR TABLE *===*===*/
    const table = document.querySelector(
      ".employee-details-report-table"
    ) as HTMLTableElement;
    if (!table) return;
    const workbook = new ExcelJS.Workbook();
    /*===*===* YOUR SHEET NAME *===*===*/
    const worksheet = workbook.addWorksheet(`Sheet 1`);
    const rows = Array.from(table.querySelectorAll("tr"));
    let excelRowIndex = 1; // Excel row index (1-based)
    const occupiedCells: Record<string, boolean> = {}; // Track occupied cells
    const colWidths: number[] = [];

    rows.forEach((row, rowIndex) => {
      const cells = Array.from(row.children) as HTMLTableCellElement[];
      let colIndex = 1; // Reset to first column for each row

      cells.forEach((cell) => {
        const cellContent = cell.textContent?.trim() || "";
        const cellLength = cellContent.length;
        const colSpan = cell.colSpan || 1;
        const rowSpan = cell.rowSpan || 1;

        colWidths[colIndex] = Math.max(
          colWidths[colIndex] || 10,
          cellLength + 2
        );
        /*===*===* Find the next available column (skip occupied columns) *===*===*/
        while (occupiedCells[`${excelRowIndex}-${colIndex}`]) {
          colIndex++;
        }
        /*===*===* SET VALUE AND TABLE STYLE *===*===*/
        const excelCell = worksheet.getRow(excelRowIndex).getCell(colIndex);
        const numericValue = Number(cellContent.replace(/,/g, ""));
        if (
          !isNaN(numericValue) &&
          cellContent.replace(/,/g, "").match(/^\d+(\.\d+)?$/)
        ) {
          excelCell.value = numericValue; // Store as a real number
        } else {
          excelCell.value = cellContent; // Store as text
        }
        // excelCell.value = cellContent;
        excelCell.alignment = { horizontal: "center", vertical: "middle" };
        excelCell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };

        /*===*===* HEADER STYLE *===*===*/
        if (rowIndex === 0) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffabab" },
          };
        }
        /*===*===* LAST ROW STYLE *===*===*/
        // if (rowIndex === rows.length - 1) {
        //   excelCell.font = { bold: true };
        //   excelCell.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "D9E1F2" },
        //   };
        // }
        /*===*===* HANDEL colSpan AND rowSpan *===*===*/
        if (colSpan > 1 || rowSpan > 1) {
          const startCell = worksheet
            .getRow(excelRowIndex)
            .getCell(colIndex).address;
          const endCell = worksheet
            .getRow(excelRowIndex + rowSpan - 1)
            .getCell(colIndex + colSpan - 1).address;
          worksheet.mergeCells(`${startCell}:${endCell}`);
          // Mark merged cells as occupied
          for (let r = 0; r < rowSpan; r++) {
            for (let c = 0; c < colSpan; c++) {
              occupiedCells[`${excelRowIndex + r}-${colIndex + c}`] = true;
            }
          }
        }
        colIndex += colSpan;
      });

      excelRowIndex++; // Move to next row
    });

    worksheet.columns = colWidths.map((width) => ({ width }));
    /*===*===* SAVE THE FILE  *===*===*/
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        `Attendance Summary Report-${moment().format(
          "DD-MM-YYYY_hh-mm-A"
        )}.xlsx`
      );
    });
  };
  const [showfilterColumns, setShowFilterColumns] = React.useState(false);
  const initialValues = {
    filter_columns: [
      "sr_name",
      "visit_date",
      "market_in_time",
      "market_out_time",
      "start_time",
      "end_time",
    ],
  };
  const columns = [
    { label: "Sales Representative", value: "sr_name" },
    { label: "Attendance Date", value: "visit_date" },
    { label: "Market in Time", value: "market_in_time" },
    { label: "Market out time", value: "market_out_time" },
    { label: "Distributor in Time", value: "start_time" },
    { label: "Distributor out Time", value: "end_time" },
  ];

  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };

  return (
    <>
      {AttendanceSummaryReportList && AttendanceSummaryReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h4 className="m-0">
                      Attendance Summary Report
                      <>
                        <p
                          style={{
                            fontSize: 16,
                            lineHeight: "24px",
                            margin: 0,
                          }}
                        >
                          For Period :-{" "}
                          {AttendanceSummaryReportDetails.from_date &&
                            AttendanceSummaryReportDetails.to_date &&
                            `( ${moment(
                              AttendanceSummaryReportDetails.from_date
                            ).format("DD/MM/YYYY")} - ${moment(
                              AttendanceSummaryReportDetails.to_date
                            ).format("DD/MM/YYYY")} )`}{" "}
                        </p>
                      </>
                    </Typography.h4>
                    <div className="position-relative d-flex">
                      {isPrintAccess && (
                        <Button
                          style={{ marginRight: 5 }}
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={() =>
                            handlePrint(
                              {
                                ...AttendanceSummaryReportDetails,
                                initialValues: {
                                  filter_columns:
                                    formRenderProps.valueGetter(
                                      "filter_columns"
                                    ),
                                },
                              },
                              "attendancesummaryreport"
                            )
                          }
                        >
                          Print
                        </Button>
                      )}
                      {isExcelAccess && (
                        <Button
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={handleExportExcel}
                          style={{ marginRight: 10 }}
                        >
                          Excel Export
                        </Button>
                      )}
                      <Tooltip
                        anchorElement="target"
                        position="left"
                        parentTitle={true}
                      >
                        <Button
                          title="Filter Columns"
                          type="button"
                          themeColor={"primary"}
                          fillMode={"solid"}
                          onClick={() => setShowFilterColumns(true)}
                        >
                          Filter
                          <BsThreeDotsVertical />
                        </Button>
                      </Tooltip>
                      {showfilterColumns && (
                        <div
                          style={{
                            position: "absolute",
                            top: "32px",
                            right: "0",
                            background: "white",
                            padding: "12px",
                            border: "1px solid whitesmoke",
                            width: "250px",
                            zIndex: 1,
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-baseline">
                            <p className="m-0 fw-600">Filter</p>
                            <Button
                              themeColor={"primary"}
                              fillMode={"flat"}
                              onClick={() => setShowFilterColumns(false)}
                            >
                              <RxCross2 />
                            </Button>
                          </div>
                          <hr className="m-1" style={{ color: "lightgray" }} />
                          <Field
                            wrapperClassName="d-flex flex-column checkBoxGroup-vertical"
                            inputClassName="checkBoxGroup-vertical-input"
                            id={"filter_columns"}
                            name={"filter_columns"}
                            marginRight={0}
                            marginBeetween={8}
                            component={FormCheckboxGroup}
                            options={columns}
                          />
                        </div>
                      )}
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      maxHeight: "calc(100vh - 340px)",
                      overflow: "scroll",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className="table table-bordered w-100  employee-details-report-table"
                      style={{
                        marginTop: 1,
                      }}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                            position: "sticky",
                            top: 0,
                          }}
                        >
                          {checkInclude("sr_name", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>
                              Sales Representaive
                            </th>
                          )}
                          {checkInclude("visit_date", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Attendance Date</th>
                          )}
                          {checkInclude("market_in_time", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Market in Time</th>
                          )}
                          {checkInclude("market_out_time", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>Market out Time</th>
                          )}
                          {checkInclude("start_time", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>
                              Distributor in Time
                            </th>
                          )}
                          {checkInclude("end_time", formRenderProps) && (
                            <th style={{ minWidth: 150 }}>
                              Distributor out Time
                            </th>
                          )}
                        </tr>
                      </thead>
                      {/* Table Body */}
                      <tbody>
                        {AttendanceSummaryReportList.map(
                          (item: any, rowIndex: number) => (
                            <>
                              <tr key={rowIndex}>
                                {checkInclude("sr_name", formRenderProps) && (
                                  <td>{item?.sr_name}</td>
                                )}
                                {checkInclude(
                                  "visit_date",
                                  formRenderProps
                                ) && (
                                  <td>
                                    {item?.visit_date
                                      ? moment(
                                          item?.visit_date,
                                          "DD/MM/YYYY"
                                        ).format("DD-MMM-YYYY")
                                      : ""}
                                  </td>
                                )}
                                {checkInclude(
                                  "market_in_time",
                                  formRenderProps
                                ) && (
                                  <td>
                                    {item?.market_in_time
                                      ? moment(
                                          item?.market_in_time,
                                          "HH:mm:ss"
                                        ).format("h:mm:ss A")
                                      : ""}
                                  </td>
                                )}
                                {checkInclude(
                                  "market_out_time",
                                  formRenderProps
                                ) && (
                                  <td>
                                    {" "}
                                    {item?.market_out_time
                                      ? moment(
                                          item?.market_out_time,
                                          "HH:mm:ss"
                                        ).format("h:mm:ss A")
                                      : ""}{" "}
                                  </td>
                                )}
                                {checkInclude(
                                  "start_time",
                                  formRenderProps
                                ) && (
                                  <td>
                                    {" "}
                                    {item?.start_time
                                      ? moment(
                                          item?.start_time,
                                          "HH:mm:ss"
                                        ).format("h:mm:ss A")
                                      : ""}
                                  </td>
                                )}
                                {checkInclude("end_time", formRenderProps) && (
                                  <td>
                                    {" "}
                                    {item?.end_time
                                      ? moment(
                                          item?.end_time,
                                          "HH:mm:ss"
                                        ).format("h:mm:ss A")
                                      : ""}
                                  </td>
                                )}
                              </tr>
                            </>
                          )
                        )}
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default AttendanceSummaryReportForm;
